import {
    CATEGORY_UPDATE_SUCCESS,
    CATEGORY_UPDATE_START,
    CATEGORY_UPDATE_ERROR
} from '../../../constants/index';
import showToaster from '../../../helpers/toastrMessgaes/showToaster';
import { updateSubCategoryStatusMutation, getAllSubCategoryQuery } from '../../../lib/graphql';

export default function updateSubCategoryStatus(id, currentPage, fieldName, fieldValue) {
    return async (dispatch, getState, { client }) => {

        try {
            dispatch({
                type: CATEGORY_UPDATE_START
            });

            const { data } = await client.mutate({
                mutation: updateSubCategoryStatusMutation,
                variables: {
                    id,
                    fieldName,
                    fieldValue
                },
                refetchQueries: [{ query: getAllSubCategoryQuery, variables: { currentPage, searchList: '' } }]
            });

            if (data?.updateSubCategoryStatus?.status == 200) {
                dispatch({
                    type: CATEGORY_UPDATE_SUCCESS
                });
                showToaster({ messageId: 'statusSubCatSuccess', requestContent: id, toasterType: 'success' });
            } else {
                dispatch({
                    type: CATEGORY_UPDATE_ERROR
                });

                showToaster({ messageId: 'errorMessage', requestContent: data?.updateSubCategoryStatus?.errorMessage, toasterType: 'error' });

            }
        } catch (err) {
            showToaster({ messageId: 'catchMessage', requestContent: err, toasterType: 'error' });
            dispatch({
                type: CATEGORY_UPDATE_ERROR
            });
        }

    }
};